import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-printer',
  templateUrl: './page-printer.component.html',
  styleUrls: ['./page-printer.component.css']
})
export class PagePrinterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
